<div class="sidebarContainer">
  <div class="sidebar" [ngClass]="{ active: !sideExp }">
    <div class="menubar-icon">
      <li class="nav-item">
        <a class="nav-link">
          <span
            class="icon"
            (click)="expandCollaspse()"
            (keydown.enter)="expandCollaspse()"
          >
            <i class="pi pi-bars"></i>
          </span>
          <span class="menu-txt">Menu</span>
        </a>
      </li>
    </div>

    <nav class="main-nav">
      <ul class="main-menu">
        @if (selectedApps == "audio") {
          <li
            class="menu-item"
            routerLink="/main/postcall/fileUpload"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon">
                  <i class="fa-solid fa-cloud-arrow-up"></i
                ></span>
                <span class="menu-txt">File Upload</span>
              </div>
            </a>
          </li>
          <li
            class="menu-item"
            routerLink="/main/postcall/progress"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon"><i class="fa fa-tasks"></i></span>
                <span class="menu-txt">Progress Monitor</span>
              </div>
            </a>
          </li>
          <li
            class="menu-item"
            routerLink="/main/postcall/audioRecords"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon"><i class="fa fa-file-audio"></i></span>
                <span class="menu-txt">Voice Analytics</span>
              </div>
            </a>
          </li>
        }
        @if (selectedApps == "email") {
          <li
            class="menu-item"
            routerLink="/main/email/emailfileUpload"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon"
                  ><i class="fa-solid fa-cloud-arrow-up"></i
                ></span>
                <span class="menu-txt">File Upload</span>
              </div>
            </a>
          </li>
          <li
            class="menu-item"
            routerLink="/main/email/autoEmailRecords"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon"
                  ><i class="fa-solid fa-envelope"></i
                ></span>
                <span class="menu-txt">Email Analytics</span>
              </div>
            </a>
          </li>
        }

        @if (selectedApps == "voiceMail") {
          <li
            class="menu-item"
            routerLink="/main/voiceemailfileUpload"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon"
                  ><i class="fa-solid fa-cloud-arrow-up"></i
                ></span>
                <span class="menu-txt">File Upload</span>
              </div>
            </a>
          </li>
          <li
            class="menu-item"
            routerLink="/main/postcall/progress"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon"><i class="fa fa-tasks"></i></span>
                <span class="menu-txt">Progress Monitor</span>
              </div>
            </a>
          </li>
          <li
            class="menu-item"
            routerLink="/main/voiceMailRecords"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon"
                  ><i class="fa-solid fa-voicemail"></i
                ></span>
                <span class="menu-txt">Voice Mail Analytics</span>
              </div>
            </a>
          </li>
        }
        @if (selectedApps == "survey") {
          <li
            class="menu-item"
            routerLink="/main/surveyRecords"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon"
                  ><i class="fa-solid fa-square-check"></i
                ></span>
                <span class="menu-txt">Survey Analytics</span>
              </div>
            </a>
          </li>
        } @else if (selectedApps == "ivr") {
          <li
            class="menu-item"
            routerLink="/main/fileUpload"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon"
                  ><i class="fa-solid fa-cloud-arrow-up"></i
                ></span>
                <span class="menu-txt">File Upload</span>
              </div>
            </a>
          </li>
          <li
            class="menu-item"
            routerLink="/main/postcall/progress"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon"><i class="fa fa-tasks"></i></span>
                <span class="menu-txt">Progress Monitor</span>
              </div>
            </a>
          </li>
          <li
            class="menu-item"
            routerLink="/main/ivrRecords"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon">
                  <i class="fa-solid fa-square-check"></i
                ></span>
                <span class="menu-txt">IVR Analytics</span>
              </div>
            </a>
          </li>
        } @else if (selectedApps == "text") {
          <li
            class="menu-item"
            routerLink="/main/textfileUpload"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon"
                  ><i class="fa-solid fa-cloud-arrow-up"></i
                ></span>
                <span class="menu-txt">File Upload</span>
              </div>
            </a>
          </li>
          <li
            class="menu-item"
            routerLink="/main/textRecords"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon"
                  ><i class="fa-solid fa-file-lines"></i
                ></span>
                <span class="menu-txt">Text Analytics</span>
              </div>
            </a>
          </li>
        }
        @if (selectedApps == "document") {
          <li
            class="menu-item"
            routerLink="/main/document/docfileUpload/0"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon"
                  ><i class="fa-solid fa-cloud-arrow-up"></i
                ></span>
                <span class="menu-txt">File Upload</span>
              </div>
            </a>
          </li>
          <li
            class="menu-item"
            routerLink="/main/document/docRecords"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon"><i class="fa-solid fa-file"></i></span>
                <span class="menu-txt">Documents</span>
              </div>
            </a>
          </li>
        }
        @if (
          selectedApps != "contract" &&
          selectedApps != "rfpcontract" &&
          selectedApps != "infosecurity" &&
          selectedApps != "email" &&
          selectedApps != "document"
        ) {
          @if (userDetails?.role_id === 1 || userDetails?.role_id === 0) {
            <li
              class="menu-item"
              routerLink="/main/postcall/userManagement"
              routerLinkActive="active"
            >
              <a class="menu-a">
                <div class="menu-txt-hld">
                  <span class="menu-icon"><i class="fa fa-users"></i></span>
                  <span class="menu-txt">User Management</span>
                </div>
              </a>
            </li>
          }
        }
        @if (selectedApps == "email") {
          @if (userDetails?.role_id === 1 || userDetails?.role_id === 0) {
            <li
              class="menu-item"
              routerLink="/main/email/userManagement"
              routerLinkActive="active"
            >
              <a class="menu-a">
                <div class="menu-txt-hld">
                  <span class="menu-icon"><i class="fa fa-users"></i></span>
                  <span class="menu-txt">User Management</span>
                </div>
              </a>
            </li>
          }
          @if (userDetails?.role_id === 1 || userDetails?.role_id === 0) {
            <li
              class="menu-item"
              routerLink="/main/email/emailconfiguration"
              routerLinkActive="active"
            >
              <a class="menu-a">
                <div class="menu-txt-hld">
                  <span class="menu-icon"
                    ><i class="fa-solid fa-gears"></i
                  ></span>
                  <span class="menu-txt">Configuration</span>
                </div>
              </a>
            </li>
          }
        } @else if (selectedApps == "voiceMail") {
          <!-- voicemail configurations -->
        } @else if (selectedApps == "document") {
          @if (userDetails?.role_id === 1 || userDetails?.role_id === 0) {
            <li
              class="menu-item"
              routerLink="/main/document/configuration"
              routerLinkActive="active"
            >
              <a class="menu-a">
                <div class="menu-txt-hld">
                  <span class="menu-icon"
                    ><i class="fa-solid fa-gears"></i
                  ></span>
                  <span class="menu-txt">Configuration</span>
                </div>
              </a>
            </li>
          }
        } @else if (selectedApps == "ivr") {
        } @else if (selectedApps == "text") {
          @if (userDetails?.role_id === 1 || userDetails?.role_id === 0) {
            <li
              class="menu-item"
              routerLink="/main/emailconfiguration"
              routerLinkActive="active"
            >
              <a class="menu-a">
                <div class="menu-txt-hld">
                  <span class="menu-icon"
                    ><i class="fa-solid fa-gears"></i
                  ></span>
                  <span class="menu-txt">Configuration</span>
                </div>
              </a>
            </li>
          }
        } @else if (
          selectedApps != "contract" &&
          selectedApps != "rfpcontract" &&
          selectedApps != "infosecurity"
        ) {
          @if (userDetails?.role_id === 1 || userDetails?.role_id === 0) {
            <li
              class="menu-item"
              routerLink="/main/postcall/configuration"
              routerLinkActive="active"
            >
              <a class="menu-a">
                <div class="menu-txt-hld">
                  <span class="menu-icon"
                    ><i class="fa-solid fa-gears"></i
                  ></span>
                  <span class="menu-txt">Configuration</span>
                </div>
              </a>
            </li>
          }
        }
        @if (selectedApps == "contract") {
          <li
            class="menu-item"
            routerLink="/main/contracts/training"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon">
                  <img
                    class="active"
                    src="../../../assets/images/brain-circuit-active.svg"
                    height="35"
                    width="35" alt=""
                  />
                  <img
                    class="inactive"
                    src="../../../assets/images/brain-circuit-inactive.svg"
                    height="35"
                    width="35" alt=""
                  />
                </span>
                <span class="menu-txt">AI Training</span>
              </div>
            </a>
          </li>
          <li
            class="menu-item"
            routerLink="/main/contracts/global-search"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon"><i class="bi bi-globe"></i></span>
                <span class="menu-txt"> Global Q&A</span>
              </div>
            </a>
          </li>
          @if (userDetails?.role_id === 1 || userDetails?.role_id === 0) {
            <li
              class="menu-item"
              routerLink="/main/contracts/feedback"
              routerLinkActive="active"
            >
              <a class="menu-a">
                <div class="menu-txt-hld">
                  <span class="menu-icon"
                    ><i class="bi bi-chat-right-text"></i
                  ></span>
                  <span class="menu-txt">Feedback</span>
                </div>
              </a>
            </li>
          }

          <li
            class="menu-item"
            routerLink="/main/contracts/config"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon"><i class="fa-solid fa-gears"></i></span>
                <span class="menu-txt">Configuration</span>
              </div>
            </a>
          </li>
        }
        @if (selectedApps == "rfpcontract") {
          <li
            class="menu-item"
            routerLink="/main/rfpcontracts/rfptraining"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon">
                  <img
                    class="active"
                    src="../../../assets/images/brain-circuit-active.svg"
                    height="35"
                    width="35" alt=""
                  />
                  <img
                    class="inactive"
                    src="../../../assets/images/brain-circuit-inactive.svg"
                    height="35"
                    width="35" alt=""
                  />
                </span>
                <span class="menu-txt">AI Training</span>
              </div>
            </a>
          </li>
          <li
            class="menu-item"
            routerLink="/main/rfpcontracts/createContract"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon"><i class="bi bi-card-text"></i></span>
                <span class="menu-txt">Create</span>
              </div>
            </a>
          </li>

          <li
            class="menu-item"
            routerLink="/main/rfpcontracts/repository"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon"><i class="bi bi-folder"></i></span>
                <span class="menu-txt">Repository</span>
              </div>
            </a>
          </li>
          <li
            class="menu-item"
            routerLink="/main/rfpcontracts/global-search"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon"><i class="bi bi-globe"></i></span>
                <span class="menu-txt"> Global Q&A</span>
              </div>
            </a>
          </li>
          @if (userDetails?.role_id === 1 || userDetails?.role_id === 0) {
            <li
              class="menu-item"
              routerLink="/main/rfpcontracts/feedback"
              routerLinkActive="active"
            >
              <a class="menu-a">
                <div class="menu-txt-hld">
                  <span class="menu-icon"
                    ><i class="bi bi-chat-right-text"></i
                  ></span>
                  <span class="menu-txt">Feedback</span>
                </div>
              </a>
            </li>
          }
          @if (userDetails?.role_id === 1 || userDetails?.role_id === 0) {
            <li
              class="menu-item"
              routerLink="/main/rfpcontracts/config"
              routerLinkActive="active"
            >
              <a class="menu-a">
                <div class="menu-txt-hld">
                  <span class="menu-icon"
                    ><i class="fa-solid fa-gears"></i
                  ></span>
                  <span class="menu-txt">Configuration</span>
                </div>
              </a>
            </li>
          }
           @if (userDetails?.role_id === 1 || userDetails?.role_id === 0) {
            <li
              class="menu-item"
              routerLink="/main/rfpcontracts/tracker"
              routerLinkActive="active"
            >
              <a class="menu-a">
                <div class="menu-txt-hld">
                  <span class="menu-icon"
                    ><i class="fa-solid fa-list-check"></i
                  ></span>
                  <span class="menu-txt">RFP Tracker</span>
                </div>
              </a>
            </li>
          }
        }
        @if (selectedApps == "infosecurity") {
          <li
            class="menu-item"
            routerLink="/main/infosecurity/training"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon">
                  <img
                    class="active"
                    src="../../../assets/images/brain-circuit-active.svg"
                    height="35"
                    width="35" alt=""
                  />
                  <img
                    class="inactive"
                    src="../../../assets/images/brain-circuit-inactive.svg"
                    height="35"
                    width="35" alt=""
                  />
                </span>
                <span class="menu-txt">AI Training</span>
              </div>
            </a>
          </li>
          <li
            class="menu-item"
            routerLink="/main/infosecurity/createContract"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon"><i class="bi bi-card-text"></i></span>
                <span class="menu-txt">Create</span>
              </div>
            </a>
          </li>

          <li
            class="menu-item"
            routerLink="/main/infosecurity/repository"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon"><i class="bi bi-folder"></i></span>
                <span class="menu-txt"> Repository</span>
              </div>
            </a>
          </li>
          <li
            class="menu-item"
            routerLink="/main/infosecurity/global-search"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon"><i class="bi bi-globe"></i></span>
                <span class="menu-txt"> Global Q&A</span>
              </div>
            </a>
          </li>
          @if (userDetails?.role_id === 1 || userDetails?.role_id === 0) {
            <li
              class="menu-item"
              routerLink="/main/infosecurity/feedback"
              routerLinkActive="active"
            >
              <a class="menu-a">
                <div class="menu-txt-hld">
                  <span class="menu-icon"
                    ><i class="bi bi-chat-right-text"></i
                  ></span>
                  <span class="menu-txt">Feedback</span>
                </div>
              </a>
            </li>
          }
          <li
            class="menu-item"
            routerLink="/main/infosecurity/config"
            routerLinkActive="active"
          >
            <a class="menu-a">
              <div class="menu-txt-hld">
                <span class="menu-icon"><i class="fa-solid fa-gears"></i></span>
                <span class="menu-txt">Configuration</span>
              </div>
            </a>
          </li>
        }
        @if (selectedApps == "contract") {
          @if (userDetails?.role_id === 1 || userDetails?.role_id === 0) {
            <li
              class="menu-item"
              routerLink="/main/contracts/contract-filter"
              routerLinkActive="active"
            >
              <a class="menu-a">
                <div class="menu-txt-hld">
                  <span class="menu-icon">
                    <i class="bi bi-file-earmark-check"></i
                  ></span>
                  <span class="menu-txt">Contract Status</span>
                </div>
              </a>
            </li>
          }

          @if (userDetails?.role === 102 && false) {
            <li
              class="menu-item"
              routerLink="/main/contracts/inbox"
              routerLinkActive="active"
            >
              <a class="menu-a">
                <div class="menu-txt-hld">
                  <span class="menu-icon"> <i class="bi bi-inbox"></i></span>
                  <span class="menu-txt">Inbox</span>
                </div>
              </a>
            </li>
          }
        }
      </ul>
    </nav>
    <div class="forUList" id="profile-setting">
      <li class="menu-item">
        <a class="menu-a">
          <div class="menu-txt-hld">
            <span class="menu-icon">
              @if (showProfileImage) {
                <img
                  (error)="onImageError()"
                  class="profile-img"
                  [src]="userimage"
                  width="36"
                  height="36" alt=""
                />
              }
              @if (!showProfileImage) {
                <i class="fa fa-user-circle" style="font-size: 36px"></i>
              }
              @if (!profile) {
                <i class="fa fa-user"></i>
              }
            </span>
            @if (sideExp) {
              <span class="menu-txt">{{ userDetails?.username }}</span>
            }
            @if (!sideExp) {
              <span class="menu-txt">{{ userDetails?.username }}</span>
            }
          </div>
        </a>
      </li>
      @if (userDetails?.role_id === 1 || userDetails?.role_id === 0) {
        <li
          class="menu-item"
          routerLink="/main/rfpcontracts/user_management"
          routerLinkActive="active"
        >
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa fa-users"></i></span>
              <span class="menu-txt">User Management</span>
            </div>
          </a>
        </li>
      }
      <li
        class="menu-item"
        routerLink="/main/settings"
        routerLinkActive="active"
      >
        <a class="menu-a">
          <div class="menu-txt-hld">
            <span class="menu-icon"><i class="fa fa-cog"></i></span>
            <span class="menu-txt">Settings</span>
          </div>
        </a>
      </li>

      <li
        class="menu-item"
        (click)="clearStorage()"
        (keydown.enter)="clearStorage()"
      >
        <a class="menu-a">
          <div class="menu-txt-hld">
            <span class="menu-icon"
              ><i class="fa fa-sign-out" style="transform: rotate(180deg)"></i
            ></span>
            <span class="menu-txt">Logout</span>
          </div>
        </a>
      </li>
    </div>
  </div>
</div>
